<template>
    <v-container>
        <h2>Profile</h2>
            <v-form ref="profileForm" @submit.prevent="save" class="custom_profile-form">
                <v-card class="mt-4 custom_v-card">
                    <v-row no-gutters>
                        <v-card-title class="py-0">
                            Profile Settings
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="px-4">
                            <v-card-actions>
                                <v-btn
                                    :disabled="disabledProfile"
                                    type="submit"
                                    class="btn_custom-color"
                                    @click="saveAdminUserProfile"
                                >SAVE CHANGES
                                </v-btn>
                            </v-card-actions>
                        </div>
                    </v-row>

                    <v-divider></v-divider>

                    <v-spacer></v-spacer>

                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-3 pr-5">
                                <b>First Name</b>
                            </div>
                        </v-col>
            
                        <v-col cols="6">
                            <v-text-field
                                v-model="adminUser.adminUserFirstName"
                                outlined
                                dense 
                                clearable
                                :rules="adminUserFirstNameRules"
                                :success="adminUserFirstNameSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-3 pr-5">
                                <b>Last Name</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="adminUser.adminUserLastName"
                                outlined
                                dense 
                                clearable
                                :rules="adminUserLastNameRules"
                                :success="adminUserLastNameSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="2" align="right" class="mr-3">
                            <div class="mt-3 pr-5">
                                <b>Email</b>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                disabled
                                v-model="adminUser.adminUserEmail"
                                outlined
                                dense 
                                type = "email"
                                :rules="adminUserEmailRules"
                                :success="adminUserEmailSuccess"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-alert v-if="errorMessageProfile" type="error">
                                {{errorMessageProfile}}
                            </v-alert>
                            <v-alert v-if="successMessageProfile" type="success">
                                {{successMessageProfile}}
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card>
            </v-form>

            <v-form ref="passwordForm" @submit.prevent="save" class="custom_profile-form">
                <v-card class="mt-8 custom_v-card">
                    <v-row no-gutters>
                        <v-card-title class="py-0">
                            Change Password
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <div class="px-4">
                            <v-card-actions>
                                <v-btn
                                    :disabled="disabledPassword"
                                    type="submit"
                                    class="btn_custom-color"
                                    @click="saveAdminUserPassword"
                                >SAVE CHANGES
                                </v-btn>
                            </v-card-actions>
                        </div>
                    </v-row>
                <v-divider></v-divider>
            <v-spacer></v-spacer>
        <v-row no-gutters class="mt-4">
            <v-col cols="2" align="right" class="mr-3">
                <div class="mt-3 pr-5">
                    <b>Old Password</b>
                </div>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    v-model="adminUser.adminUserPassword"
                    outlined
                    dense 
                    ref="password"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="adminUserPasswordRules"
                    :success="adminUserPasswordSuccess"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="2" align="right" class="mr-3">
                <div class="mt-3 pr-5">
                    <b> New Password</b>
                </div>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    v-model="newPassword"
                    outlined
                    dense 
                    ref="password"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="newPasswordRules"
                    :success="newPasswordSuccess"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="2" align="right" class="mr-3">
                <div class="mt-3 pr-5">
                    <b>Confirm Password</b>
                </div>
            </v-col>
            <v-col cols="6">
                <v-text-field
                    v-model="confirmPassword"
                    outlined
                    dense 
                    ref="password"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="confirmPasswordRules"
                    :success="confirmPasswordSuccess"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6">
                <v-alert v-if="errorMessagePassword" type="error">
                   {{errorMessagePassword}}
                </v-alert>
                <v-alert v-if="successMessagePassword" type="success">
                   {{successMessagePassword}}
                </v-alert>
            </v-col>
        </v-row>
    </v-card>
   </v-form>
  </v-container>
</template>

<script>
import AdminUser from "../../models/AdminUser";
import {mapMutations } from "vuex";
import url1 from '../../../config.js';
export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                  {
                      vm.$router.push("/");
                  }
            }, 0);
        });
    },
    name: "EditAdminUserProfile",
    data() {
        return {
                url:`${url1.url}`,
                disabledProfile:false,
                disabledPassword:false,
                errorMessageProfile:'',
                errorMessagePassword:'',
                successMessageProfile:'', 
                successMessagePassword:'', 
                adminUserFirstName:'',
                serverError: "",
                valid: false,
                disabled: false,
                adminUser: new AdminUser(),

                adminUserEmail: "",
                adminUserPassword: "",
                newPassword:'',
                confirmPassword:'',
                showPassword: false,

                // Validation Rules for First Form
                adminUserFirstNameSuccess:false,  
                adminUserFirstNameRules: [
                v => {
                    if (v)
                    {
                        this.adminUserFirstNameSuccess = true;
                        return true;
                    } else {
                        this.adminUserFirstNameSuccess = false;
                        return "First Name is required";
                    }
                },
                v =>
                    (v || "").length >= 2 ||
                    "First name must be at least 2 characters long",
                v =>
                    (v || "").length <= 30 ||
                    "First name must be less than 30 characters",
            
                ],

                adminUserLastNameSuccess:false,
                adminUserLastNameRules: [
                v => {
                    if (v)
                    {
                        this.adminUserLastNameSuccess = true;
                        return true;
                    }
                    else {
                        return "Last Name is required";
                    }
                },
                v =>
                    (v || "").length >= 4 ||
                    "Last name must be at least 4 characters long",
                v =>
                    (v || "").length <= 30 ||
                    "Last name must be less than 30 characters",
                ],

                adminUserEmailSuccess: false,
                adminUserEmailRules: [
                v => 
                    {
                    if (v) {
                        this.adminUserEmailSuccess = true;
                        return true;
                    } else {
                        return "Email is required";
                    }

                },
                v =>
                    (v || "").length >= 5 ||
                    "Admin user email must be at least 5 characters long",
                v =>
                    (v || "").length <= 255 ||
                    "Name must be less than 255 characters",
                    v => /.+@.+\..+/.test(v) || "E-mail must be valid"
                ],

                // Validation Rules for second Form
                adminUserPasswordSuccess: false,
                adminUserPasswordRules: [
                v => 
                    {
                    if (v) {
                        this.adminUserPasswordSuccess = true;
                        return true;
                    } else {
                        return "Password is required";
                    }
                },
                v =>
                    (v || "").length >=8 ||
                    "Password must be at least 8 characters long",
                ],

                newPasswordSuccess: false,
                newPasswordRules: [
                v => 
                    {
                    if (v) {
                        this.newPasswordSuccess = true;
                        return true;
                    } else {
                        return "New Password is required";
                    }
                },
                v =>
                    (v || "").length >=8 ||
                    "Password must be at least 8 characters long",
                ],

                confirmPasswordSuccess: false,
                confirmPasswordRules: [    
                v => 
                    {
                    if (v) {
                        this.confirmPasswordSuccess = true;
                        return true;
                    } else {
                        return "Confirm Password is required";
                    }
                },
                v => {    
                        if (v===this.newPassword) {
                            this.confirmPasswordSuccess = true;
                            return true;
                        } else {
                            return "Confirm Password should be same as new password";
                        }
                    },
                v =>
                    (v || "").length >=8 ||
                    "Password must be at least 8 characters long",
                ],

            }
    },

    methods:{
        ...mapMutations(["setUser"]),

        getAdminUser() {
            this.adminUser=this.auth.adminUser;
            this.adminUser.adminUserPassword='';
        },

        saveAdminUserProfile() 
        {
            this.disabledProfile = true;
            if(this.adminUser.adminUserFirstName.length<2||this.adminUser.adminUserFirstName.length>30)
            {
                this.errorMessageProfile = 'Please enter valid first name';
                setTimeout(() => (this.errorMessageProfile = ""), 5000);
                // this.$refs.profileForm.reset();
                this.disabledProfile = false;
                return;
            }
            if(this.adminUser.adminUserLastName.length<4||this.adminUser.adminUserLastName.length>30)
            {
                this.errorMessageProfile = 'Please enter valid lastname';
                setTimeout(() => (this.errorMessageProfile = ""), 5000);
                // this.$refs.profileForm.reset();
                this.disabledProfile = false;
                return;
            }

            AdminUser.putProfile(this.auth.token, this.adminUser._id, this.adminUser )
                .then(res => {
                    console.log('res.data', res.data);
                    this.adminUser.adminUserPassword='';
                    this.setUser(this.adminUser);
                    this.successMessageProfile = 'Profile changed successfully';
                    setTimeout(() => (this.successMessageProfile = ""), 5000);
                    this.disabledProfile = false;
                    })
                .catch(err => {
                    this.errorMessageProfile = err.response.data;
                    setTimeout(() => (this.errorMessageProfile = ""), 5000);
                    console.log('error occured while updating profile');
                    this.disabledProfile = false;
                    });
            },

        saveAdminUserPassword() {
            this.disabledPassword = true;
            if(this.adminUser.adminUserPassword.length<8)
                {
                    this.errorMessagePassword = 'Old password should be atleast 8 character long';
                    setTimeout(() => (this.errorMessagePassword = ""), 5000);
                    this.disabledPassword = false;
                return;
                }

                if(this.newPassword.length<8)
                {
                    this.errorMessagePassword = 'New password should be atleast 8 character long';
                    setTimeout(() => (this.errorMessagePassword = ""), 5000);
                    this.disabledPassword = false;
                    return;
                }

                if(this.confirmPassword.length<8||this.newPassword!=this.confirmPassword)
                {
                    this.errorMessagePassword = 'Confirm password should be same as new password';
                    setTimeout(() => (this.errorMessagePassword = ""), 5000);
                    this.disabledPassword = false;
                    return;
                }
                this.disabledPassword = true;

                AdminUser.putPassword(this.auth.token,this.adminUser._id, this.adminUser.adminUserPassword, this.newPassword)
                    .then(res => {
                        console.log('res', res);
                        this.successMessagePassword = 'Password changed successfully';
                        setTimeout(() => (this.successMessagePassword = ""), 5000);
                        this.$refs.passwordForm.reset();
                        this.disabledPassword=false;
                    })
                    .catch(err => {
                        this.errorMessagePassword = err.response.data;
                        setTimeout(() => (this.errorMessagePassword = ""), 5000);
                        this.disabledPassword = false;
                    });
            },

        clearForm(){
                this.$refs.form.resetValidation();
            }
    },

    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },
    mounted() {
        this.getAdminUser()
         }


}
</script>
<style scoped>
.custom_v-card {
    border-top: 3px solid #1b73ba;
}
.v-card__title {
    font-size: 18px;
}
/*
.for_custom-badge >>> .v-badge__badge .v-icon {
    font-size: 16px;
    color: #fff;
}
.for_custom-badge >>> .v-badge__badge {
    height: 30px;
    min-width: 30px;
    border-radius: 50%;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.for_custom-badge >>> .v-badge__badge .v-avatar {
    height: 25px !important;
}
*/
.custom_profile-form {
    font-size: 14px;
}
.v-card__actions{
    padding:4px 8px;
}
</style>